import { globalTourSteps } from 'constants/tour';

export const workloadsTourId = 'workloads';

export const tourSteps = {
  filters: 'workloads-filters',
  nameCell: 'workload-name-cell',
  rowCheckbox: 'workload-row-checkbox',
};

export const workloadsTourStepsOrder = [
  tourSteps.filters,
  tourSteps.nameCell,
  tourSteps.rowCheckbox,
  globalTourSteps.connectMyCluster,
];
